module.exports = __webpack_public_path__ + "static/media/calendar-remove.e6e6addb.svg";